import * as yup from 'yup'

export const attendancePayrollSchema = (__: (key: string) => string) => {
  return yup.object().shape({
    net_pay: yup
      .number()
      .transform((value, originalValue) => {
        return originalValue === '' || originalValue === null ? undefined : value
      })
      .typeError(__('Net Pay must be a number'))
      .min(0)
      .notRequired(),
    gross_pay: yup
      .number()
      .transform((value, originalValue) => {
        return originalValue === '' || originalValue === null ? undefined : value
      })
      .typeError(__('Gross Pay must be a number'))
      .min(0)
      .notRequired(),
    daily_wage: yup
      .number()
      .typeError(__('Daily Wage must be a number'))
      .min(0)
      .required(__('Daily Wage is required'))
  })
}
